// extracted by mini-css-extract-plugin
export default {"centeredCntainer":"NavButton_centeredCntainer__vjh1V","animContainer":"NavButton_animContainer__u4d4m"};